import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { StreamChat } from "stream-chat";
import {
  Chat,
  Channel,
  ChannelList,
  MessageList,
  MessageInput,
  Window,
  Thread,
  ChannelHeader,
} from "stream-chat-react";
import "stream-chat-react/dist/css/index.css";
import useLivlyUser from "@/context/UserProvider";
import useLivlyChat from "@/context/ChatProvider";

// Simple dev helper page to explore Stream Chat channels.
// This page is ONLY mounted when import.meta.env.VITE_ENVIRONMENT is DEV.

export default function AmbassadorChatPage() {
  if (import.meta.env.VITE_ENVIRONMENT !== "DEV") {
    return <div>Not available</div>;
  }

  return <ChatExplorer />;
}

function ChatExplorer() {
  const { chatClient } = useLivlyChat();
  const { user } = useLivlyUser();

  if (!chatClient) return null;

  return (
    <Chat client={chatClient}>
      <ChannelList
        filters={{
          type: "prospect_ambassador",
          members: { $in: [user.streamUserId] },
        }}
        sort={[{ last_message_at: -1 }]}
      />
      <Channel>
        <Window>
          <ChannelHeader />
          <MessageList returnAllReadData />
          <MessageInput focus />
        </Window>
        <Thread virtualized />
      </Channel>
    </Chat>
  );
}
